import {
  Button,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { formatTimestamp } from 'shared/dates';
import { useAuthState } from 'state/useAuthState';
import { InfoRow } from '../InfoRow';
import { NgfsDetectionPoi } from './PoiDialog.types';
import { EMPTY_DATA_VALUE } from '../../../../../constants';

const NGFS_LEARN_MORE_URL =
  'https://support.watchduty.org/hc/en-us/articles/47896549294093';

const useStyles = makeStyles()((theme) => ({
  title: {
    padding: theme.spacing(2, 6, 1, 2),
    lineHeight: '1 !important',
  },
  content: {
    padding: theme.spacing(0, 2, 2, 2),
    maxWidth: 375,
    lineHeight: '18px',
  },
}));

export const NgfsDetectionDialogContent = (
  props: NgfsDetectionPoi,
): JSX.Element => {
  const { frp, typeDescription, acquisitionEpoch } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const {
    permissions: { isInternalUser },
  } = useAuthState();

  const reportedAt = acquisitionEpoch
    ? formatTimestamp(acquisitionEpoch * 1000)
    : EMPTY_DATA_VALUE;

  return (
    <>
      <DialogTitle id="alert-dialog-title" className={classes.title}>
        <Typography
          component="span"
          variant="body2"
          sx={{ fontWeight: 'bold' }}
        >
          {t('map.poi.ngfsDetection.title')}
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Stack spacing={1}>
          <InfoRow
            title={t('map.poi.ngfsDetection.reported')}
            content={reportedAt}
          />
          {isInternalUser && (
            <InfoRow
              title={t('map.poi.ngfsDetection.type')}
              content={typeDescription ?? EMPTY_DATA_VALUE}
            />
          )}
          <InfoRow
            title={t('map.poi.ngfsDetection.frp')}
            content={t('map.poi.ngfsDetection.frpValue', {
              frp: frp ?? EMPTY_DATA_VALUE,
            })}
          />
          <InfoRow
            title={t('map.poi.ngfsDetection.notes')}
            content={t('map.poi.ngfsDetection.notesValue')}
          />
          <Button
            component={Link}
            size="small"
            variant="text"
            href={NGFS_LEARN_MORE_URL}
            target="_blank"
            color="neutral"
            sx={{
              width: 'fit-content',
              textDecoration: 'underline',
              p: 0,
            }}
          >
            {t('map.poi.ngfsDetection.learnMore')}
          </Button>
        </Stack>
      </DialogContent>
    </>
  );
};
